angular.module('impactx.cancellation').controller('CancellationRequestCtrl', CancellationRequestCtrl);

CancellationRequestCtrl.$inject = ['$scope', 'dataGen', '$routeParams', 'ToolbarService', 'ToastService', 'BackService'];

function CancellationRequestCtrl($scope, dataGen, $routeParams, ToolbarService, ToastService, BackService)
{
    var ctrl = this;
    
    ctrl.getOrderLink = function() {
        return "purchaseorderdetail/" + $scope.data.pohId;
    };

    ctrl.getData = function () {
        var paramObj = {
            id: $routeParams.id
        };
        dataGen.getData($scope, paramObj, '/cancellationrequest/view').then(function () {
            ToolbarService.setButtons([
                {
                    linkFunction: ctrl.getOrderLink,
                    label: $scope.trns.orderDetails,
                    type: 'link'
                },
                {
                    label: $scope.trns.abortRequest,
                    type: 'dialogAction',
                    action: abortRequest,
                    condition: canAbortRequest
                }
            ]);
        });
    };

    function canAbortRequest() {
        return $scope.data.canAbort;
    }

    function abortRequest() {
        return dataGen.postAsForm({}, {crhId: $scope.data.id}, '/cancellationrequest/abort').then(function () {
            ToastService.openStandardToast($scope.trns.rejected);
            BackService.back();
        });
    }

    ctrl.getData();
}